<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="4">
        <el-button type="primary" @click="initPage">查询</el-button>
        <el-button type="primary" @click="addFn">添加</el-button>
      </el-col>
    </Sift>
    
    <div class="table-con">
      <el-table class="w100 mt20 table" header-row-class-name="table-head" row-class-name="cu-p" stripe :data="list" height="100%">
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="card_name" label="卡片名称" maxlength="12"></el-table-column>
        <el-table-column align="center" prop="card_code" label="卡片代码"></el-table-column>
        <el-table-column align="center" prop="remark" label="备注"></el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="info" @click="editFn(scope.row)">详情</span>
              <span class="delete" @click="deleteFn(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情、新增 -->
    <AddCard ref="addCardDialog" />
    <EditCard ref="editCardDialog" />

  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import AddCard from "@/components/management/homeCard/AddCard";
import EditCard from "@/components/management/homeCard/EditCard";

export default {
  name: "HomeCard",
  components: {
    Sift,
    AddCard,
    EditCard
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData() {
      this.loading = true;
      this.siftData = [
        {
          type: "text",
          key: "cardName",
          label: "卡片名称",
          placeholder: "",
          default: ""
        },
        {
          type: "text",
          key: "cardCode",
          label: "卡片代码",
          placeholder: "",
          default: ""
        }
      ];
      this.loading = false;
      this.$nextTick(() => {
        this.initPage();
      });
    },

    // 获取查询列表
    getListFn () {
      this.loading = true;
      let data = {
        cardName: this.$refs.needSift.getValue().cardName,
        cardCode: this.$refs.needSift.getValue().cardCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };

      this.$http.get(this.$base.menhuUrl + "/tabCardInfo/findPage", { params: data })
      .then( ({data}) => {
        if (data.resCode === 0) {
          this.list = data.resData.records;
        }
        this.total = data.resData.total;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },

    // 添加
    addFn() {
      this.$refs.addCardDialog.dialogShow("");
    },

    // 删除
    deleteFn (data) {
      this.$confirm( "是否确定删除 " + data.card_name + " 卡片?", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        // 删除接口
        this.$http.delete(this.$base.menhuUrl + "/tabCardInfo/remove", {params: { cardId: data.card_id }})
        .then( ({data}) => {
          if ( data.resCode === 0 ) {
            this.$message.success(data.resMsg);
            this.initPage();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.$message.info( "已取消删除" );          
      });
    },

    // 详情
    editFn (item) {
      this.$refs.editCardDialog.dialogShow(item);
    },

    // 默认页面数据
    initPage() {
      this.pageNum = 1;
      this.getListFn();
    },

    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .table-con {
    height: calc(100vh - 270px);
  }
  
  .to-use {
    width: 100%;
  }
  
  .to-use span {
    padding: 0 8px;
    display: inline-block;
  }
  
  .to-use .info {
    color: #409EFF;
  }
  
  .to-use .delete {
    color: #cdcdcd;
  }
  
  .to-use .info:hover {
    color: #336ab1;
  }
  
  .to-use .delete:hover {
    color: #606266;
  }
</style>
